import React, { useState, useEffect } from "react";
import {
  getFallbackImageForNewsFeed,
  getImageLink,
} from "../../utils/commonUtils";
import { get } from "lodash";

type NewsImageProps = {
  source: string;
  url: string;
  classProps: string;
  image?: string;
  fromBoard?: boolean;
};

const NewsImage: React.FC<NewsImageProps> = ({
  source,
  url,
  classProps,
  image,
  fromBoard,
}) => {
  const [imageSrc, setImageSrc] = useState<string>(
    "https://www.bing.com/th?id=OVFT.94fhU2WuyPqa4wDZIRambS&pid=News"
  );

  useEffect(() => {
    const fetchImage = async () => {
      const fallbackImage = await getFallbackImageForNewsFeed(
        source,
        url,
        image,
        fromBoard
      );
      setImageSrc(fallbackImage);
    };

    fetchImage();
  }, [source, url]);

  return <img alt={source} className={classProps} src={imageSrc} />;
};

export default NewsImage;
